/**
 * 與後端 api/src/constants/defaultPointsExpiryReminderTemplates.js 文案同步
 */

export const DEFAULT_POINTS_EXPIRY_LINE_BODY =
  '{{memberName}} 您好，提醒您有 {{totalPoints}} 點將於 {{expiryDate}} 到期（約 {{daysUntilExpiry}} 天內），請把握時間使用。';

export const DEFAULT_POINTS_EXPIRY_SMS_BODY =
  '{{memberName}} 您好，{{totalPoints}} 點將於{{expiryDate}}到期，請盡快使用。';

export const DEFAULT_POINTS_EXPIRY_EMAIL_SUBJECT = '【點數即將到期】提醒';

export const DEFAULT_POINTS_EXPIRY_EMAIL_BODY = `{{memberName}} 您好，

您有 {{totalPoints}} 點將於 {{expiryDate}} 到期（約 {{daysUntilExpiry}} 天內，本次提醒設定為到期前 {{reminderDays}} 天內之點數）。

請盡快使用以免逾期失效。

祝您購物愉快！`;
